module.exports = __webpack_public_path__ + "static/img/UBIDOMO_slide-4-1500x630.b18af066.jpg";